import {MachinesService} from '../../services/machines.service';
import {Component, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Machine} from '../../models/machine.model';
import {Subject} from 'rxjs/Subject';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  providers: [MachinesService],
  selector: 'app-machines',
  styleUrls: ['./machines.component.scss'],
  templateUrl: './machines.component.html',
})
export class MachinesComponent implements OnDestroy, OnInit {
  public machines: Machine[];
  public cols: any[];

  private _selectedMachine: Machine;
  private _ngUnSubscribe: Subject<void> = new Subject<void>();

  constructor(private _route: ActivatedRoute, private _machineService: MachinesService,
              private _elementReference: ElementRef, public router: Router) {
  }

  public ngOnInit() {
    this.cols = [
      { field: 'name', header: 'Naam' },
      { field: 'type', header: 'Type' },
      { field: 'serial', header: 'Serienummer' },
      { field: 'customer.name', header: 'Klant' }
    ];

    this._machineService.loadAll(`?populate=customer`);
    this._machineService.machines$
      .takeUntil(this._ngUnSubscribe)
      .subscribe(
        machines => {
          this.machines = machines;
        }
      );
  }

  public ngOnDestroy() {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  set selectedMachine(value: Machine) {
    this._selectedMachine = value;
    this.detailsMachine();
  }
  get selectedMachine(): Machine {
    return this._selectedMachine;
  }

  public detailsMachine(): void {
    if (this.selectedMachine) {
      this.router.navigate(['/machines', this.selectedMachine._id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/machine/machines.component.ts